import AverageHoursMessage from './AverageHoursMessage';

export default AverageHoursMessage;
